import React from "react";

/**
 * Premium section banner image.
 * - Full width within its container, responsive with graceful aspect-ratio.
 * - Soft rounded corners matching the premium aesthetic.
 * - Designed to sit at the top of a section, above existing content,
 *   introducing the theme visually without disrupting layout.
 */
export default function BannerImage({ src, alt, testId, priority = false }) {
  return (
    <div
      data-testid={testId}
      className="relative w-full max-w-5xl mx-auto overflow-hidden rounded-[14px] shadow-[0_30px_80px_-24px_rgba(11,30,54,0.25)] ring-1 ring-[#0B1E36]/8 bg-white"
    >
      <img
        src={src}
        alt={alt}
        loading={priority ? "eager" : "lazy"}
        className="block w-full h-auto object-contain"
        draggable={false}
      />
    </div>
  );
}
